import { render, staticRenderFns } from "./TestingFormQuestion.vue?vue&type=template&id=af94c966&scoped=true&"
import script from "./TestingFormQuestion.vue?vue&type=script&lang=js&"
export * from "./TestingFormQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af94c966",
  null
  
)

export default component.exports